import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { REQUEST_STATUS, COMMENT_REQUIRED_STATUSES } from '../utils/requestStatus';

// bkz. docs/talep_olustur_onay_akısı.md "STATÜ DEĞİŞTİRME" — Red (40) ve İade (15) için yorum
// zorunlu, diğer statülerde (Onaya Gönder/Kabul) opsiyonel.
const TITLE_I18N_KEY = {
    [REQUEST_STATUS.PENDING_APPROVAL]: 'sendForApprovalTitle',
    [REQUEST_STATUS.ACCEPTED]: 'acceptTitle',
    [REQUEST_STATUS.REJECTED]: 'rejectTitle',
    [REQUEST_STATUS.RETURNED]: 'returnTitle'
};

/**
 * "Tüm Talepler" sekmesindeki statü geçiş aksiyonları (Onaya Gönder/Kabul/Red/İade) için ortak
 * onay + yorum diyaloğu. `POST /v1/LmsCreateRequest/ChangeStatus`'un kendisini çağırmaz — geçişi
 * gerçekleştirmek `onConfirm(comment)` üzerinden çağırana (AllRequestsTab.jsx) bırakılır.
 */
const StatusChangeDialog = ({ visible, targetStatus, onHide, onConfirm, loading }) => {
    const { th } = useLanguage();
    const [comment, setComment] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const commentRequired = COMMENT_REQUIRED_STATUSES.includes(targetStatus);

    useEffect(() => {
        if (visible) {
            setComment('');
            setSubmitted(false);
        }
    }, [visible, targetStatus]);

    const isInvalid = submitted && commentRequired && !comment.trim();
    const titleKey = TITLE_I18N_KEY[targetStatus];

    const handleConfirm = () => {
        setSubmitted(true);
        if (commentRequired && !comment.trim()) return;
        onConfirm?.(comment.trim());
    };

    return (
        <Dialog visible={visible} onHide={onHide} header={titleKey ? th(`trainingRequest.allRequests.statusChange.${titleKey}`) : ''} modal className="p-fluid" style={{ width: '30vw', minWidth: '360px' }}>
            <div className="field">
                <label htmlFor="statusChangeComment">
                    {th('trainingRequest.allRequests.statusChange.commentLabel')} {commentRequired && <span className="text-red-500">*</span>}
                </label>
                <InputTextarea
                    id="statusChangeComment"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    rows={4}
                    autoResize
                    maxLength={1000}
                    placeholder={th('trainingRequest.allRequests.statusChange.commentPlaceholder')}
                    className={isInvalid ? 'p-invalid' : ''}
                />
                {isInvalid && <small className="text-red-500">{th('trainingRequest.allRequests.statusChange.commentRequiredError')}</small>}
            </div>
            <div className="flex justify-content-end gap-2 mt-3">
                <Button label={th('common.cancel')} icon="pi pi-times" outlined onClick={onHide} type="button" />
                <Button label={th('trainingRequest.allRequests.statusChange.confirm')} icon="pi pi-check" onClick={handleConfirm} loading={!!loading} type="button" />
            </div>
        </Dialog>
    );
};

export default StatusChangeDialog;
